<template>
  <div class="view">
    <div style="height: 20vh;background: #e9c7a0;display: flex">
      <div
          style="margin-top: 3.5vh;margin-left: 3vw;height: 3vh;display: flex;align-items: center;"
          @click="$router.back()">
        <img v-if="$route.query && $route.query.showTitle" src="../../assets/images/back.png"
             style="width: 3vh;height: 3vh">
        <span style="font-size: 3vh;font-weight: 700;color: #dc6666;text-align: left;vertical-align: top;">{{
            $route.meta && $route.meta.title || ''
          }}</span>
      </div>
    </div>
    <div class="view_content_bg">
      <div class="view_content_bg_title">详情数据</div>

      <div class="view_content_bg_item" @click="openValue('眼轮匝肌肥厚')">
        <div class="view_content_bg_item_title">
          <span>眼轮匝肌肥厚</span><span>{{ eye1Index }}分</span><span>/100</span><span>{{ eye1 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="eye1" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>

      <div class="view_content_bg_item" @click="openValue('眼皱胶原')">
        <div class="view_content_bg_item_title">
          <span>眼皱胶原</span><span>{{ eye2Index }}分</span><span>/100</span><span>{{ eye2 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="eye2" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('皮下色素沉着')">
        <div class="view_content_bg_item_title">
          <span>皮下色素沉着</span><span>{{ eye3Index }}分</span><span>/100</span><span>{{ eye3 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="eye3" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('淋巴阻塞')">
        <div class="view_content_bg_item_title">
          <span>淋巴阻塞</span><span>{{ eye4Index }}分</span><span>/100</span><span>{{ eye4 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="eye4" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('松弛下垂')">
        <div class="view_content_bg_item_title">
          <span>松弛下垂</span><span>{{ eye5Index }}分</span><span>/100</span><span>{{ eye5 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="eye5" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('浮肿')">
        <div class="view_content_bg_item_title">
          <span>浮肿</span><span>{{ eye6Index }}分</span><span>/100</span><span>{{ eye6 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="eye6" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('眼周细胞活性')">
        <div class="view_content_bg_item_title">
          <span>眼周细胞活性</span><span>{{ eye7Index }}分</span><span>/100</span><span>{{ eye7 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="eye7" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>
      <div class="view_content_bg_item" @click="openValue('视力疲劳')">
        <div class="view_content_bg_item_title">
          <span>视力疲劳</span><span>{{ eye8Index }}分</span><span>/100</span><span>{{ eye8 }}</span>
        </div>
        <div class="view_content_bg_item_buttom">
          <div id="eye8" :style="{ width: '100%',height:'16px' }"></div>
        </div>
      </div>

      <div style="height: 28px"/>

    </div>
    <view_bottom></view_bottom>
  </div>
</template>

<script>
import view_bottom from '@/pages/healthy/view_bottom'
import axios from 'axios'

export default {
  name: 'ReportJ',
  components: { view_bottom },
  data() {
    return {
      eye1: '',
      eye2: '',
      eye3: '',
      eye4: '',
      eye5: '',
      eye6: '',
      eye7: '',
      eye8: '',
      eye1Index: '',
      eye2Index: '',
      eye3Index: '',
      eye4Index: '',
      eye5Index: '',
      eye6Index: '',
      eye7Index: '',
      eye8Index: '',

    }
  },
  created() {
    // document.title = '舌诊评估'
    console.log(this.$route.query)
    this.id = this.$route.query.id
    this.getcode(this.id)
  },
  methods: {
    getcode(id) {
      let url = `${this.baseUrl}/app/geteye?id=${id}`
      this.br = '<br/>'
      axios.post(url)
      axios.post(url)
          .then((result) => {
            console.log(result)
            this.eye1 = result.data.eye1
            this.eye2 = result.data.eye2
            this.eye3 = result.data.eye3
            this.eye4 = result.data.eye4
            this.eye5 = result.data.eye5
            this.eye6 = result.data.eye6
            this.eye7 = result.data.eye7
            this.eye8 = result.data.eye8
            this.eye1Index = result.data.eye1Index
            this.eye2Index = result.data.eye2Index
            this.eye3Index = result.data.eye3Index
            this.eye4Index = result.data.eye4Index
            this.eye5Index = result.data.eye5Index
            this.eye6Index = result.data.eye6Index
            this.eye7Index = result.data.eye7Index
            this.eye8Index = result.data.eye8Index
            this.initBarChart('eye1', this.eye1)
            this.initBarChart('eye2', this.eye2)
            this.initBarChart('eye3', this.eye3)
            this.initBarChart('eye4', this.eye4)
            this.initBarChart('eye5', this.eye5)
            this.initBarChart('eye6', this.eye6)
            this.initBarChart('eye7', this.eye7)
            this.initBarChart('eye8', this.eye8)

          }).catch(error => {
        //this.$router.replace("error")
      })
    },
    initBarChart(view, count) {
      let jiankang = this.$echarts.init(document.getElementById(view))
      let option = {
        grid: {
          left: '0',
          top: '0',
          right: '0',
          bottom: '0',
          containLabel: true,
          width: '100%'
        },
        xAxis: {
          type: 'value',
          splitLine: { show: false },
          axisLabel: { show: false },
          axisTick: { show: false },
          axisLine: { show: false },

        },
        yAxis: {
          type: 'category',
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: {
            color: 'black',
            fontSize: 25,
            show: false,
          },
        },
        series: [
          {
            type: 'bar',
            barWidth: 18,
            data: [count],
            label: {
              //position    : 'middle',
              offset: [20, 2],
              color: '#fff',
              fontSize: 30,
            },
            itemStyle: {
              color: this.$echarts.graphic.LinearGradient(
                  1, 0, 0, 0,
                  [
                    { offset: 0, color: '#dc6666' },                   //柱图渐变色
                    // {offset: 0.5, color: '#44C0C1'},                 //柱图渐变色
                    { offset: 1, color: '#dc6666' },                   //柱图渐变色
                  ]
              ),
              barBorderRadius: 9,
            },
            zlevel: 1
          },
          {
            name: '进度条背景',
            type: 'bar',
            barGap: '-100%',
            barWidth: 18,
            data: [100],
            color: '#E3ECF2',//柱条颜色
            itemStyle: {
              normal: {
                barBorderRadius: 9,
                borderColor: '#FEFEFE',
              }
            }
          }
        ]
      }
      jiankang.setOption(option)
    },
    openValue(info) {
      //this.$router.push({ path: '/Healthy/Introduce', query: { userId: info, date: new Date().getTime() } })
    }
  }
}
</script>

<style scoped>

.view_content_bg_item {
  background: #F7FAFA;
  border-radius: 32px;
  margin-top: 24px;
  margin-left: 32px;
  margin-right: 32px;
}

.view_content_bg_item_title {
  padding: 32px 32px 16px;
}

.view_content_bg_item_title > span:nth-child(1) {
  font-size: 28px;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  text-align: left;
  vertical-align: top;
}

.view_content_bg_item_title > span:nth-child(2) {
  font-size: 28px;
  font-weight: 400;
  color: #f14848;
  padding-left: 16px;
  text-align: left;
  vertical-align: top;
}

.view_content_bg_item_title > span:nth-child(3) {
  font-size: 24px;
  font-weight: 400;
  color: rgba(199, 199, 199, 1);
  text-align: center;
  margin-top: 4px;
  padding-left: 6px;
  vertical-align: top;
  float: right;
}

.view_content_bg_item_title > span:nth-child(4) {
  font-size: 28px;
  font-weight: 400;
  color: #dc6666;
  text-align: right;
  vertical-align: top;
  float: right;
}

.view_content_bg_item_buttom {
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 40px;
}
</style>
